import axios from "core/axios";

export default {
  getPinnedIds: (idCountry?: number | null) => {
      const params = idCountry ? `?idCountry=${idCountry}` : "";
      return axios.get(`/users/getPinnedUsers${params}`, { 
          headers: {
              "Authorization": `Bearer ${window.localStorage.accessToken}`
          }
      })
  },
  getUsersPreviews: (ids: Array<string>) => {
    const query = ids.map((el) => `idUsers=${el}`).join("&");
    return axios.get(`/users/getUsersPreviewInfo?${query}`, {
      headers: {
        Authorization: `Bearer ${window.localStorage.accessToken}`,
      },
    });
  },
}